// 引入全局变量
import val from './globalVal.js'
// 引入全局方法
import api from './globalApi.js'
// 引入接口请求方法
import { callApi } from './api.js'

import ClipboardJS from "clipboard"
import Vue from 'vue'

function copyText(text) {
  return new Promise(function (resolve, reject) {
    console.log("copyText", text);
    ClipboardJS.copy(text);
    Vue.prototype.$message.success('复制成功')
    resolve();
    if(0)
    {
      let el = document.createElement('textarea')
      el.value = text;
      document.body.appendChild(el);
      el.select();
      try{
        if(document.execCommand('copy')){
          resolve()
        }else{
          reject(new Error("execCommand fail"))
        }
      }catch(e){
        reject(e);
      }
      document.body.removeChild(el);
      el = null;
    }
  })
}
export default {
  install: Vue => {
    Vue.prototype.$val = val;
    Vue.prototype.$api = api;
    Vue.prototype.$callApi = callApi;
    Vue.prototype.$copyText = copyText;
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js